export const TutorType = {
  SWITCH_TUTOR: "TUTOR:ENABLE",
  TUTOR_STEP: "TUTOR:STEP",
  COMPONENT_REFS: "COMPONENT:REFS",
  SET_STEP: "TUTOR:SET",
  CLEAR_TUTOR: "TUTOR:CLEAR",
  START_DEV: "TUTOR:START_DEV",
  STOP_DEV: "TUTOR:STOP_DEV"
};
